import styled from "styled-components";

export const Page = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas: "main" "footer";
  overflow-x: hidden;
`;
